import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Typography,
} from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import Artifacts from "../component/app/admin/dealership/tabs/Artifacts.component";
import { SalesAidsStyles } from "../component/app/admin/dealership/tabs/SalesAidsStyles";

const AccordianUtils = ({
  Text,
  icon,
  content,
  index,
  expandedIndex,
  setExpandedIndex,
}) => {
  const expanded = index === expandedIndex;
  const handleExpansion = () => {
    setExpandedIndex(expanded ? -1 : index);
  };

  const expandIcon = expanded ? <ExpandMore /> : <KeyboardArrowRight />;

  return (
    <Accordion
      expanded={expanded}
      onChange={handleExpansion}
      sx={{
        // "&.Mui-expanded": {
        //   margin: "5px 0",
        // },
        boxShadow: "none",
      }}
    >
      <AccordionSummary
        expandIcon={expandIcon}
        sx={{
          // "&.Mui-expanded": {
          //   margin: "1px 0",
          // },
          backgroundColor: expanded ? "#00ab551a  " : "#fff",
          borderRadius: "6px",
        }}
      >
        <Box sx={SalesAidsStyles.accordianSummary}>
          {icon}
          <Typography>{Text}</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ scrollBehavior: "smooth",p:0 }}>
        {/* <Divider /> */}
        {content}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordianUtils;
